<p-dialog styleClass="email-template-editor-dialog" [closeOnEscape]="false" [closable]="false" header="Template Properties" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true" appendTo="body">
    <form *ngIf="emailTemplateForm" [formGroup]="emailTemplateForm" (ngSubmit)="submit()" class="validated-form admin-form">
      <div class="grid">
        <div class="col-1">
          <label>Disclaimer</label>
        </div>
        <div class="col-11">
          <p>The following fields determine the format of the emails that are sent out when communicating with your users. These should only be changed by personnel experienced in coding HTML. <b>Trace Solutions accepts no responsibility for changes made to these fields away from the default values.</b></p>
        </div>
      </div>

      <div class="grid">
        <div class="col-1">
          <label>Template</label>
        </div>
        <div class="col-11">
          <p>{{emailTemplate.displayName}}</p>
        </div>
      </div>

      <div class="grid">
        <div class="col-1">
          <label>Description</label>
        </div>
        <div class="col-11">
          <p>{{emailTemplate.description}}</p>
        </div>
      </div>

      <div class="grid">
        <div class="col-1">
          <label>Subject Line</label>
        </div>
        <div class="col-11">
          <input class="editable-field" type="text" pInputText formControlName="subject" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
        </div>
      </div>

      <div class="grid">
        <div class="col-1">
          <label>Body (HTML)</label>
        </div>
        <div class="col-11">
          <textarea rows="10" class="editable-field" pInputTextarea formControlName="template" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"></textarea>
        </div>
      </div>

      <div class="grid">
        <div class="col-1">
          <label>Note</label>
        </div>
        <div class="col-11">
          <p *ngIf="emailTemplate.name == 'TenantGeneralNotification'">Items shown with <span ngNonBindable>{{ }}</span> are values obtained from the tenant record or the notification centre, send notification screen.</p>
          <p *ngIf="emailTemplate.name != 'TenantGeneralNotification'">Items shown with <span ngNonBindable>{{ }}</span> are values obtained from the General Information within the System Settings on each product/database. Make sure that this information is completed and correct to make sure the correct information is included in your emails.</p>
        </div>
      </div>
    </form>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton icon="fa-fw fa fa-undo" label="Factory Reset" (click)="factoryReset($event)"></button>
      <button type="button" pButton icon="fa-fw fa fa-copy" label="Copy body to clipboard" (click)="copyBodyToClipboard($event)"></button>
      <button type="button" pButton icon="fa-fw fa fa-check" label="Save" (click)="save($event)"></button>
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel($event)" label="Cancel"></button>
    </div>
  </p-footer>
</p-dialog>